import { SxProps, Theme } from '@mui/material';

export const authGuardStyles = {
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: 120,
    p: 2,
  } as SxProps<Theme>,

  loadingText: {
    fontSize: '0.875rem',
    color: 'text.secondary',
    textAlign: 'center',
  } as SxProps<Theme>,

  authContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'background.default',
    p: 2,
    overflow: 'hidden',
    boxSizing: 'border-box',
  } as SxProps<Theme>,
};
